import {
  TripEncRow,
  generateDecryptValue,
  generateEncryptedValue,
} from "../constants/vtrTrip";
import { EffortEncRow } from "../constants/Effort";
import { CatchEncRow } from "../constants/Catch";
import { SalesEncRow } from "../constants/Sales";
import { VtrListRow } from "./vtrList";

export const ENCRYPT_VALUE = "ENCRYPT";
export const DECRYPT_VALUE = "DECRYPT";

export const encryptVtrList = function (vtrListArray, client_id) {
  let vtrList = [];
  let vtrListLength = 0;
  let vtrCounter = 0;
  if (Array.isArray(vtrListArray)) {
    vtrListLength = vtrListArray.length;
    if (vtrListLength > 0) {
      for (let c = 0; c < vtrListLength; c++) {
        vtrList[vtrCounter] = encryptVtrListObject(vtrListArray[c], client_id);
        vtrCounter++;
      }
    }
  }
  return vtrList;
};

export const decryptVtrList = function (vtrListArray, client_id) {
  let vtrList = [];
  let vtrListLength = 0;
  let vtrCounter = 0;
  if (Array.isArray(vtrListArray)) {
    vtrListLength = vtrListArray.length;
    if (vtrListArray.length > 0) {
      for (let c = 0; c < vtrListLength; c++) {
        vtrList[vtrCounter] = decryptVtrListObject(vtrListArray[c], client_id);
        vtrCounter++;
      }
    }
  }
  return vtrList;
};

function decryptVtrListObject(vtrListObject, client_id) {
  let vtr = new VtrListRow();
  vtr.setDateLand(generateDecryptValue(vtrListObject.DATE_LAND, client_id));
  vtr.setDateSail(generateDecryptValue(vtrListObject.DATE_SAIL, client_id));
  vtr.setDocId(generateDecryptValue(vtrListObject.DOCID, client_id));
  vtr.setIsLocked(generateDecryptValue(vtrListObject.IS_LOCKED, client_id));
  vtr.setSubmissionType(
    generateDecryptValue(vtrListObject.SUBMISSION_TYPE, client_id)
  );
  vtr.setTripId(generateDecryptValue(vtrListObject.TRIP_ID, client_id));
  vtr.setVesselPermitNum(
    generateDecryptValue(vtrListObject.VESSEL_PERMIT_NUM, client_id)
  );
  vtr.setLowestSerialNum(
    generateDecryptValue(vtrListObject.LOWEST_SERIAL_NUM, client_id)
  );
  return vtr;
}

function encryptVtrListObject(vtrListObject, client_id) {
  let vtr = new VtrListRow();
  vtr.setDateLand(generateEncryptedValue(vtrListObject.DATE_LAND, client_id));
  vtr.setDateSail(generateEncryptedValue(vtrListObject.DATE_SAIL, client_id));
  vtr.setDocId(generateEncryptedValue(vtrListObject.DOCID, client_id));
  vtr.setIsLocked(generateEncryptedValue(vtrListObject.IS_LOCKED, client_id));
  vtr.setSubmissionType(
    generateEncryptedValue(vtrListObject.SUBMISSION_TYPE, client_id)
  );
  vtr.setTripId(generateEncryptedValue(vtrListObject.TRIP_ID, client_id));
  vtr.setVesselPermitNum(
    generateEncryptedValue(vtrListObject.VESSEL_PERMIT_NUM, client_id)
  );
  vtr.setLowestSerialNum(
    generateEncryptedValue(vtrListObject.LOWEST_SERIAL_NUM, client_id)
  );
  return vtr;
}

function encryptCatch(catchObject, client_id) {
  let fish = new CatchEncRow();
  fish.setSpecies(generateEncryptedValue(catchObject.species, client_id));
  fish.setKept(generateEncryptedValue(catchObject.kept, client_id));
  fish.setDiscarded(generateEncryptedValue(catchObject.discarded, client_id));
  fish.setUom(generateEncryptedValue(catchObject.uom, client_id));
  return fish;
}

function encryptEffort(effort, client_id) {
  let encEffort = new EffortEncRow();
  if (effort.hasOwnProperty("serial_num")) {
    encEffort.setSerialNum(
      generateEncryptedValue(effort.serial_num, client_id)
    );
  }
  encEffort.setGearCode(generateEncryptedValue(effort.gearcode, client_id));
  encEffort.setGearName(generateEncryptedValue(effort.gearname, client_id));
  encEffort.setMeshSize(generateEncryptedValue(effort.mesh_size, client_id));
  encEffort.setGearQty(generateEncryptedValue(effort.gearqty, client_id));
  encEffort.setGearSize(generateEncryptedValue(effort.gearsize, client_id));
  encEffort.setNumberOfHauls(
    generateEncryptedValue(effort.number_of_hauls, client_id)
  );
  let rawSoakTime = effort.tow_soak_time;
  if (
    rawSoakTime &&
    rawSoakTime.hasOwnProperty("hours") &&
    rawSoakTime.hasOwnProperty("minutes")
  ) {
    let soakHrs = generateEncryptedValue(rawSoakTime.hours, client_id);
    let soakMinutes = generateEncryptedValue(rawSoakTime.minutes, client_id);
    encEffort.setSoakTime(soakHrs, soakMinutes);
  }
  encEffort.setLanLongFormat(
    generateEncryptedValue(effort.lat_long_format, client_id)
  );
  let latitude = {};
  if (effort.latitude_or_loran1 !== null) {
    latitude.decimal_degrees = generateEncryptedValue(
      effort.latitude_or_loran1.decimal_degrees,
      client_id
    );
    latitude.degrees_decimal_minutes = {
      degrees: generateEncryptedValue(
        effort.latitude_or_loran1.degrees_decimal_minutes.degrees,
        client_id
      ),
      minutes: generateEncryptedValue(
        effort.latitude_or_loran1.degrees_decimal_minutes.minutes,
        client_id
      ),
    };
    latitude.degrees_minutes_seconds = {
      degrees: generateEncryptedValue(
        effort.latitude_or_loran1.degrees_minutes_seconds.degrees,
        client_id
      ),
      minutes: generateEncryptedValue(
        effort.latitude_or_loran1.degrees_minutes_seconds.minutes,
        client_id
      ),
      seconds: generateEncryptedValue(
        effort.latitude_or_loran1.degrees_minutes_seconds.seconds,
        client_id
      ),
    };
  }
  let longitude = {};
  if (effort.longitude_or_loran2 !== null) {
    longitude.decimal_degrees = generateEncryptedValue(
      effort.longitude_or_loran2.decimal_degrees,
      client_id
    );
    longitude.degrees_decimal_minutes = {
      degrees: generateEncryptedValue(
        effort.longitude_or_loran2.degrees_decimal_minutes.degrees,
        client_id
      ),
      minutes: generateEncryptedValue(
        effort.longitude_or_loran2.degrees_decimal_minutes.minutes,
        client_id
      ),
    };
    longitude.degrees_minutes_seconds = {
      degrees: generateEncryptedValue(
        effort.longitude_or_loran2.degrees_minutes_seconds.degrees,
        client_id
      ),
      minutes: generateEncryptedValue(
        effort.longitude_or_loran2.degrees_minutes_seconds.minutes,
        client_id
      ),
      seconds: generateEncryptedValue(
        effort.longitude_or_loran2.degrees_minutes_seconds.seconds,
        client_id
      ),
    };
  }
  encEffort.setLatitude(latitude);
  encEffort.setLongitude(longitude);
  encEffort.setChartArea(generateEncryptedValue(effort.chart_area, client_id));
  encEffort.setFishingDepth(
    generateEncryptedValue(effort.fishing_depth, client_id)
  );
  encEffort.setFishingDepthUom(
    generateEncryptedValue(effort.fishing_depth_uom, client_id)
  );
  if (effort.hasOwnProperty("catch") && Array.isArray(effort.catch)) {
    const effortCatch = effort.catch;
    const nrCatch = effortCatch.length;
    if (nrCatch > 0) {
      let catchArray = [];
      let catchCounter = 0;
      for (let c = 0; c < nrCatch; c++) {
        catchArray[catchCounter] = encryptCatch(effortCatch[c], client_id);
        catchCounter++;
      }
      encEffort.setCatch(catchArray);
    }
  }
  if (
    effort.hasOwnProperty("numTrapsHauled") &&
    effort.hasOwnProperty("numTrapsInWater") &&
    effort.hasOwnProperty("numTrapsPerString") &&
    effort.hasOwnProperty("numBuoyLines") &&
    effort.hasOwnProperty("stringsHauled") &&
    effort.hasOwnProperty("avgSoakTime")
  ) {
    encEffort.setNumTrapsHauled(
      generateEncryptedValue(effort.numTrapsHauled, client_id)
    );
    encEffort.setNumTrapsInWater(
      generateEncryptedValue(effort.numTrapsInWater, client_id)
    );
    encEffort.setNumTrapsPerString(
      generateEncryptedValue(effort.numTrapsPerString, client_id)
    );
    encEffort.setNumBuoyLines(
      generateEncryptedValue(effort.numBuoyLines, client_id)
    );
    encEffort.setStringsHauled(
      generateEncryptedValue(effort.stringsHauled, client_id)
    );
    encEffort.setAvgSoakTime(
      generateEncryptedValue(effort.avgSoakTime, client_id)
    );
  }
  return encEffort;
}

export const decryptSales = function (salesObject, client_id) {
  let market = new SalesEncRow();
  market.setSpecies(generateDecryptValue(salesObject.species, client_id));
  market.setDealerPermitNumber(
    generateDecryptValue(salesObject.dealer_permit_number, client_id)
  );
  market.setSold(generateDecryptValue(salesObject.sold, client_id));
  market.setDateSold(generateDecryptValue(salesObject.date_sold, client_id));
  market.setOffLoadingPort(
    generateDecryptValue(salesObject.offloading_port, client_id)
  );
  market.setUom(generateDecryptValue(salesObject.uom, client_id));
  market.setDealerName(
    generateDecryptValue(salesObject.dealer_name, client_id)
  );
  market.setPricePerBushel(
    generateDecryptValue(salesObject.price_per_bushel, client_id)
  );
  const allocationNumbers = generateDecryptValue(
    salesObject.allocation_numbers,
    client_id
  );
  const tagNumbers = generateDecryptValue(salesObject.tag_numbers, client_id);
  if (
    allocationNumbers !== null &&
    allocationNumbers !== undefined &&
    allocationNumbers !== ""
  ) {
    market.setAllocationNumbers(JSON.parse(allocationNumbers));
  }
  if (tagNumbers !== null && tagNumbers !== undefined && tagNumbers !== "") {
    market.setTagNumbers(JSON.parse(tagNumbers));
  }
  return market;
};

export const encryptSales = function (salesObject, client_id) {
  let market = new SalesEncRow();
  market.setSpecies(generateEncryptedValue(salesObject.species, client_id));
  market.setDealerPermitNumber(
    generateEncryptedValue(salesObject.dealer_permit_number, client_id)
  );
  market.setSold(generateEncryptedValue(salesObject.sold, client_id));
  market.setDateSold(generateEncryptedValue(salesObject.date_sold, client_id));
  market.setOffLoadingPort(
    generateEncryptedValue(salesObject.offloading_port, client_id)
  );
  market.setUom(generateEncryptedValue(salesObject.uom, client_id));
  market.setDealerName(
    generateEncryptedValue(salesObject.dealer_name, client_id)
  );
  market.setPricePerBushel(
    generateEncryptedValue(salesObject.price_per_bushel, client_id)
  );
  market.setAllocationNumbers(
    generateEncryptedValue(
      JSON.stringify(salesObject.allocation_numbers),
      client_id
    )
  );
  market.setTagNumbers(
    generateEncryptedValue(JSON.stringify(salesObject.tag_numbers), client_id)
  );
  return market;
};

export const encryptTrip = function (trip, client_id) {
  let newTripEncObject = new TripEncRow();
  newTripEncObject.setTripId(generateEncryptedValue(trip.trip_id, client_id));
  newTripEncObject.setDateSail(
    generateEncryptedValue(trip.date_sail, client_id)
  );
  newTripEncObject.setDateLand(
    generateEncryptedValue(trip.date_land, client_id)
  );
  newTripEncObject.setNoEffortTripReason(
    generateEncryptedValue(trip.no_effort_trip_reason, client_id)
  );
  newTripEncObject.setNumberOfAnglers(
    generateEncryptedValue(trip.number_of_anglers, client_id)
  );
  newTripEncObject.setNumberOfCrew(
    generateEncryptedValue(trip.number_of_crew, client_id)
  );
  newTripEncObject.setOperatorFirstName(
    generateEncryptedValue(trip.operator_first_name, client_id)
  );
  newTripEncObject.setOperatorMiddleName(
    generateEncryptedValue(trip.operator_middle_name, client_id)
  );
  newTripEncObject.setOperatorLastName(
    generateEncryptedValue(trip.operator_last_name, client_id)
  );
  newTripEncObject.setOperatorExtName(
    generateEncryptedValue(trip.operator_ext_name, client_id)
  );
  newTripEncObject.setOperatorPermitNumber(
    generateEncryptedValue(trip.operator_permit_number, client_id)
  );
  newTripEncObject.setReportType(
    generateEncryptedValue(trip.report_type, client_id)
  );
  newTripEncObject.setVesselPermitNum(
    generateEncryptedValue(trip.vessel_permit_num, client_id)
  );
  newTripEncObject.setTripType(
    generateEncryptedValue(trip.trip_type, client_id)
  );
  newTripEncObject.setVesselName(
    generateEncryptedValue(trip.vessel_name, client_id)
  );
  newTripEncObject.setVesselRegistration(
    generateEncryptedValue(trip.vessel_registration, client_id)
  );
  newTripEncObject.setSubmittedTrip(
    generateEncryptedValue(trip.submitted_trip, client_id)
  );
  newTripEncObject.setSubmittedSuccess(
    generateEncryptedValue(trip.submitted_success, client_id)
  );
  newTripEncObject.setLowestSerialNum(
    generateEncryptedValue(trip.lowest_serial_num, client_id)
  );
  newTripEncObject.setSubmissionType(
    generateEncryptedValue(trip.submission_type, client_id)
  );
  newTripEncObject.setBuoyLines(
    generateEncryptedValue(trip.buoyLines, client_id)
  );
  newTripEncObject.setTrapsPerString(
    generateEncryptedValue(trip.trapsPerString, client_id)
  );
  newTripEncObject.setTrapsInWater(
    generateEncryptedValue(trip.trapsInWater, client_id)
  );
  newTripEncObject.setTripStatus(
    generateEncryptedValue(trip.trip_status, client_id)
  );
  newTripEncObject.setDefaultUOM(
    generateEncryptedValue(trip.default_uom, client_id)
  );
  newTripEncObject.setDefaultSpeciesUOM(
    generateEncryptedValue(trip.default_species_uom, client_id)
  );

  if (trip.hasOwnProperty("images") && Array.isArray(trip.images)) {
    const tripSubTrips = trip.images;
    const nrImages = tripSubTrips.length;
    let savedSubTripsArray = [];
    let imageCounter = 0;
    if (nrImages > 0) {
      for (let e = 0; e < nrImages; e++) {
        savedSubTripsArray[imageCounter] = encryptEffort(
          tripSubTrips[e],
          client_id
        );
        imageCounter++;
      }
      newTripEncObject.images = savedSubTripsArray;
    }
  }
  if (trip.hasOwnProperty("sales") && Array.isArray(trip.sales)) {
    let savedSalesArray = [];
    let salesCounter = 0;
    const tripSales = trip.sales;
    const nrSales = tripSales.length;
    if (nrSales > 0) {
      for (let s = 0; s < nrSales; s++) {
        savedSalesArray[salesCounter] = encryptSales(tripSales[s], client_id);
        salesCounter++;
      }
      newTripEncObject.sales = savedSalesArray;
    }
  }

  return newTripEncObject;
};

export const decryptTrip = function (trip, client_id) {
  let t = new TripEncRow();
  t.setTripId(generateDecryptValue(trip.trip_id, client_id));
  t.setReportType(generateDecryptValue(trip.report_type, client_id));
  t.setTripType(generateDecryptValue(trip.trip_type, client_id));
  t.setNumberOfAnglers(generateDecryptValue(trip.number_of_anglers, client_id));
  t.setNumberOfCrew(generateDecryptValue(trip.number_of_crew, client_id));
  t.setOperatorFirstName(
    generateDecryptValue(trip.operator_first_name, client_id)
  );
  t.setOperatorMiddleName(
    generateDecryptValue(trip.operator_middle_name, client_id)
  );
  t.setOperatorLastName(
    generateDecryptValue(trip.operator_last_name, client_id)
  );
  t.setOperatorExtName(generateDecryptValue(trip.operator_ext_name, client_id));
  t.setOperatorPermitNumber(
    generateDecryptValue(trip.operator_permit_number, client_id)
  );
  t.setDateSail(generateDecryptValue(trip.date_sail, client_id));
  t.setNumberOfCrew(generateDecryptValue(trip.number_of_crew, client_id));
  t.setNumberOfAnglers(generateDecryptValue(trip.number_of_anglers, client_id));
  t.setVesselPermitNum(generateDecryptValue(trip.vessel_permit_num, client_id));
  t.setVesselName(generateDecryptValue(trip.vessel_name, client_id));
  t.setVesselRegistration(
    generateDecryptValue(trip.vessel_registration, client_id)
  );
  t.setDateLand(generateDecryptValue(trip.date_land, client_id));
  t.setNoEffortTripReason(
    generateDecryptValue(trip.no_effort_trip_reason, client_id)
  );
  t.setSubmittedTrip(generateDecryptValue(trip.submitted_trip, client_id));
  t.setSubmittedSuccess(
    generateDecryptValue(trip.submitted_success, client_id)
  );
  t.setSubmissionType(generateDecryptValue(trip.submission_type, client_id));
  t.setLowestSerialNum(generateDecryptValue(trip.lowest_serial_num, client_id));
  t.setBuoyLines(generateDecryptValue(trip.buoyLines, client_id));
  t.setTrapsPerString(generateDecryptValue(trip.trapsPerString, client_id));
  t.setTrapsInWater(generateDecryptValue(trip.trapsInWater, client_id));
  t.setTripStatus(generateDecryptValue(trip.trip_status, client_id));
  t.setDefaultUOM(generateDecryptValue(trip.default_uom, client_id));
  t.setDefaultSpeciesUOM(
    generateDecryptValue(trip.default_species_uom, client_id)
  );

  if (trip.hasOwnProperty("images") && Array.isArray(trip.images)) {
    let tripSubTrips = trip.images;
    let savedSubTripsArray = [];
    for (let e = 0; e < tripSubTrips.length; e++) {
      let i = new EffortEncRow();
      i.setChartArea(
        generateDecryptValue(tripSubTrips[e].chart_area, client_id)
      );
      i.setGearCode(generateDecryptValue(tripSubTrips[e].gearcode, client_id));
      if (tripSubTrips[e].hasOwnProperty("gear_name")) {
        i.setGearName(
          generateDecryptValue(tripSubTrips[e].gear_name, client_id)
        );
      }

      i.setMeshSize(generateDecryptValue(tripSubTrips[e].mesh_size, client_id));
      i.setGearQty(generateDecryptValue(tripSubTrips[e].gearqty, client_id));
      i.setGearSize(generateDecryptValue(tripSubTrips[e].gearsize, client_id));
      i.setLanLongFormat(
        generateDecryptValue(tripSubTrips[e].lat_long_format, client_id)
      );
      let latitude = {};
      if (tripSubTrips[e].latitude_or_loran1 !== null) {
        latitude.decimal_degrees = generateDecryptValue(
          tripSubTrips[e].latitude_or_loran1.decimal_degrees,
          client_id
        );
        latitude.degrees_decimal_minutes = {
          degrees: generateDecryptValue(
            tripSubTrips[e].latitude_or_loran1.degrees_decimal_minutes.degrees,
            client_id
          ),
          minutes: generateDecryptValue(
            tripSubTrips[e].latitude_or_loran1.degrees_decimal_minutes.minutes,
            client_id
          ),
        };
        latitude.degrees_minutes_seconds = {
          degrees: generateDecryptValue(
            tripSubTrips[e].latitude_or_loran1.degrees_minutes_seconds.degrees,
            client_id
          ),
          minutes: generateDecryptValue(
            tripSubTrips[e].latitude_or_loran1.degrees_minutes_seconds.minutes,
            client_id
          ),
          seconds: generateDecryptValue(
            tripSubTrips[e].latitude_or_loran1.degrees_minutes_seconds.seconds,
            client_id
          ),
        };
      }
      let longitude = {};
      if (tripSubTrips[e].longitude_or_loran2 !== null) {
        longitude.decimal_degrees = generateDecryptValue(
          tripSubTrips[e].longitude_or_loran2.decimal_degrees,
          client_id
        );
        longitude.degrees_decimal_minutes = {
          degrees: generateDecryptValue(
            tripSubTrips[e].longitude_or_loran2.degrees_decimal_minutes.degrees,
            client_id
          ),
          minutes: generateDecryptValue(
            tripSubTrips[e].longitude_or_loran2.degrees_decimal_minutes.minutes,
            client_id
          ),
        };
        longitude.degrees_minutes_seconds = {
          degrees: generateDecryptValue(
            tripSubTrips[e].longitude_or_loran2.degrees_minutes_seconds.degrees,
            client_id
          ),
          minutes: generateDecryptValue(
            tripSubTrips[e].longitude_or_loran2.degrees_minutes_seconds.minutes,
            client_id
          ),
          seconds: generateDecryptValue(
            tripSubTrips[e].longitude_or_loran2.degrees_minutes_seconds.seconds,
            client_id
          ),
        };
      }
      i.setLatitude(latitude);
      i.setLongitude(longitude);
      i.setNumberOfHauls(
        generateDecryptValue(tripSubTrips[e].number_of_hauls, client_id)
      );
      i.setFishingDepth(
        generateDecryptValue(tripSubTrips[e].fishing_depth, client_id)
      );
      i.setFishingDepthUom(
        generateDecryptValue(tripSubTrips[e].fishing_depth_uom, client_id)
      );
      let rawSoakTime = tripSubTrips[e].tow_soak_time;
      if (
        rawSoakTime &&
        rawSoakTime.hasOwnProperty("hours") &&
        rawSoakTime.hasOwnProperty("minutes")
      ) {
        let soakHrs = generateDecryptValue(rawSoakTime.hours, client_id);
        let soakMinutes = generateDecryptValue(rawSoakTime.minutes, client_id);
        i.setSoakTime(soakHrs, soakMinutes);
      }
      i.setSerialNum(
        generateDecryptValue(tripSubTrips[e].serial_num, client_id)
      );
      if (
        tripSubTrips[e].hasOwnProperty("catch") &&
        Array.isArray(tripSubTrips[e].catch)
      ) {
        let subTripCatch = tripSubTrips[e].catch;
        let catches = [];
        for (let a = 0; a < subTripCatch.length; a++) {
          let c = new CatchEncRow();
          c.setSpecies(
            generateDecryptValue(subTripCatch[a].species, client_id)
          );
          c.setUom(generateDecryptValue(subTripCatch[a].uom, client_id));
          c.setKept(generateDecryptValue(subTripCatch[a].kept, client_id));
          c.setDiscarded(
            generateDecryptValue(subTripCatch[a].discarded, client_id)
          );
          catches[catches.length] = c;
        }
        i.setCatch(catches);
      }
      // Adding lobster info if/when present
      if (
        tripSubTrips[e].hasOwnProperty("numTrapsHauled") &&
        tripSubTrips[e].hasOwnProperty("numTrapsInWater") &&
        tripSubTrips[e].hasOwnProperty("numTrapsPerString") &&
        tripSubTrips[e].hasOwnProperty("numBuoyLines") &&
        tripSubTrips[e].hasOwnProperty("stringsHauled") &&
        tripSubTrips[e].hasOwnProperty("avgSoakTime")
      ) {
        i.setNumTrapsHauled(
          generateDecryptValue(tripSubTrips[e].numTrapsHauled, client_id)
        );
        i.setNumTrapsInWater(
          generateDecryptValue(tripSubTrips[e].numTrapsInWater, client_id)
        );
        i.setNumTrapsPerString(
          generateDecryptValue(tripSubTrips[e].numTrapsPerString, client_id)
        );
        i.setNumBuoyLines(
          generateDecryptValue(tripSubTrips[e].numBuoyLines, client_id)
        );
        i.setStringsHauled(
          generateDecryptValue(tripSubTrips[e].stringsHauled, client_id)
        );
        i.setAvgSoakTime(
          generateDecryptValue(tripSubTrips[e].avgSoakTime, client_id)
        );
      }
      savedSubTripsArray[savedSubTripsArray.length] = i;
    }
    t.images = savedSubTripsArray;
    let tripSales = [];
    let nrSales = 0;
    if (trip.hasOwnProperty("sales") && Array.isArray(trip.sales)) {
      tripSales = trip.sales;
      nrSales = tripSales.length;
    }
    if (nrSales > 0) {
      let sales = [];
      let salesCounter = 0;
      for (let a = 0; a < tripSales.length; a++) {
        sales[salesCounter] = decryptSales(tripSales[a], client_id);
        salesCounter++;
      }
      t.sales = sales;
    }
  }
  return t;
};
